import Reveal from "@/components/base/Reveal";
import { aboutValues } from "@/mocks/about";

export default function AboutPrinciples() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <div>
              <span className="inline-flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.24em] text-primary-600">
                <span className="h-px w-7 bg-primary-400" aria-hidden="true" />
                Çalışma İlkelerimiz
              </span>
              <h2 className="mt-5 font-heading text-3xl font-medium leading-tight tracking-tight text-foreground-950 md:text-4xl">
                Şeffaflık, etik ve sürekli gelişim
              </h2>
              <p className="mt-6 text-base leading-relaxed text-foreground-600">
                Sağlık hizmetinde güven, görünür olmayan detaylarda başlar. Aşağıdaki dört ilke,
                merkezimizin günlük çalışma pratiğini tanımlar.
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <Reveal delay={100}>
              <ul className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-100">
                {aboutValues.map((value) => (
                  <li key={value.title} className="p-6 transition-colors hover:bg-background-50/70 md:p-7">
                    <h3 className="font-heading text-base font-medium tracking-tight text-foreground-950">
                      {value.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.text}</p>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}